import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Modal from '../modal/modal.component'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { MuvicardService } from '../../services/muvicard.service'
import { toastActions } from '../../actions'
import { STATE } from '../../constants'
import './muvicard-modal.style.scss'

class MuvicardItemAction extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isOpen: false,
			status: STATE.TO_BLOCK,
			canUpdateStatus: true,
		}
	}

	componentWillMount() {
		this.getCardInfo()
	}

	closeModal = () => {
		this.setState({ isOpen: false })
	}

	alterStatusCard = async () => {
		const { showLoading, hideLoading, toastError, toastSuccess } = this.props

		showLoading()

		const { status } = this.state

		try {
			if (status === STATE.ACTIVE) {
				await MuvicardService.CardBlock()
				toastSuccess({
					message: 'Cartão bloqueado com sucesso.',
				})
				this.setState({ status: STATE.UNLOCK })
			} else if (status === STATE.LOCKED) {
				await MuvicardService.CardUnblock()
				toastSuccess({
					message: 'Cartão desbloqueado com sucesso.',
				})
				this.setState({ status: STATE.TO_BLOCK })
			}
		} catch (error) {
			toastError({
				message: 'Não foi possível alterar o estatos deste cartão.',
			})
		}

		this.closeModal()

		hideLoading()
	}

	getCardInfo = async () => {
		const { showLoading, hideLoading, toastError } = this.props

		const { errors, data } = await MuvicardService.GetCardInfo()

		showLoading()

		if (errors && errors.length > 0) {
			toastError({ message: errors })
			return
		}

		if (data.status === STATE.ACTIVE) {
			this.setState({ status: STATE.TO_BLOCK, canUpdateStatus: true })
		} else if (data.status === STATE.LOCKED) {
			this.setState({
				status: STATE.UNLOCK,
				canUpdateStatus: true,
			})
		} else {
			this.setState({
				status: STATE.TO_BLOCK,
				canUpdateStatus: false,
			})
		}

		hideLoading()
	}

	render() {
		const { menuOptionPath, closeMobileMenu, title, iconItem, route } =
			this.props

		return (
			<div className="item-container">
				<Link to={route}>
					<div
						onClick={(e) => {
							e.preventDefault()
							this.setState({ isOpen: true })
							closeMobileMenu()
							menuOptionPath(route)
						}}>
						<svg width="35px" height="30px" viewBox="0 0 17 21">
							<path d={iconItem} />
						</svg>
						<span>{title}</span>
					</div>
				</Link>
				<Modal
					noPadding
					animation="fadeIn"
					isOpen={this.state.isOpen}
					onClose={() => this.closeModal()}>
					<div className="container-modal-muvicard">
						{this.state.canUpdateStatus ? (
							<div>
								<h3>
									Deseja realmente {this.state.status} o seu cartão?
								</h3>

								<footer>
									<button onClick={() => this.closeModal()}>
										Cancelar
									</button>
									<button
										onClick={() => this.alterStatusCard()}
										disabled={!this.state.canUpdateStatus}>
										Confirmar
									</button>
								</footer>
							</div>
						) : (
							<div>
								<h3>Cartão inválido para bloqueio e desbloqueio</h3>
								<footer>
									<button onClick={() => this.closeModal()}>
										Fechar
									</button>
								</footer>
							</div>
						)}
					</div>
				</Modal>
			</div>
		)
	}
}

const mapStateToProps = ({ site }) => ({
	menuOptionPath: site.menuOptionPath,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			menuOptionPath: SiteCreators.menuOptionPath,
			closeMobileMenu: SiteCreators.closeMobileMenu,
			closePrivateMenu: SiteCreators.closePrivateMenu,
			showLoading: SiteCreators.showLoading,
			hideLoading: SiteCreators.hideLoading,
			toastSuccess: toastActions.success,
			toastError: toastActions.danger,
		},
		dispatch
	)

export default connect(mapStateToProps, mapDispatchToProps)(MuvicardItemAction)
